const UPDATE_EXPIRIES = 'UPDATE_EXPIRIES';
const UPDATE_FORMATTED_EXPIRIES = 'UPDATE_FORMATTED_EXPIRIES';
const UPDATE_ASSET_SYMBOL = 'UPDATE_ASSET_SYMBOL';
const UPDATE_OPEN_INTEREST_SELECTED_EXPIRIES = 'UPDATE_OPEN_INTEREST_SELECTED_EXPIRIES';
const TOGGLE_OPEN_INTEREST_SELECTED_EXPIRIES = 'TOGGLE_OPEN_INTEREST_SELECTED_EXPIRIES';
const UPDATE_MAX_PAIN = 'UPDATE_MAX_PAIN';
const TOGGLE_OPEN_INTEREST_ALL_EXPIRIES = 'TOGGLE_OPEN_INTEREST_ALL_EXPIRIES';

// Implied Volatility
const UPDATE_IMPLIED_VOLATILITY_SELECTED_EXPIRIES =
  'UPDATE_IMPLIED_VOLATILITY_SELECTED_EXPIRIES';
const UPDATE_IMPLIED_VOLATILITY_ASSET_SYMBOL = 'UPDATE_IMPLIED_VOLATILITY_ASSET_SYMBOL';
const TOGGLE_IMPLIED_VOLATILITY_SELECTED_EXPIRY =
  'TOGGLE_IMPLIED_VOLATILITY_SELECTED_EXPIRY';
// Volume Strike Chart
const UPDATE_VOLUME_STRIKE_CHART_ACTIVE_ASSET_SYMBOL =
  'UPDATE_VOLUME_STRIKE_CHART_ACTIVE_ASSET_SYMBOL';
const UPDATE_VOLUME_STRIKE_CHART_INITIAL_SELECTED_EXPIRIES =
  'UPDATE_VOLUME_STRIKE_CHART_INITIAL_SELECTED_EXPIRIES';
const TOGGLE_VOLUME_STRIKE_CHART_ALL_EXPIRIES = 'TOGGLE_VOLUME_STRIKE_CHART_ALL_EXPIRIES';
const TOGGLE_VOLUME_STRIKE_CHART_SELECTED_EXPIRIES =
  'TOGGLE_VOLUME_STRIKE_CHART_SELECTED_EXPIRIES';

// Open Interest Change Chart Action Types
const UPDATE_OI_CHANGE_ASSET_SYMBOL = 'UPDATE_OI_CHANGE_ASSET_SYMBOL';
const UPDATE_OI_CHANGE_EXPIRIES = 'UPDATE_OI_CHANGE_EXPIRIES';
const UPDATE_OI_CHANGE_TIME_PERIOD = 'UPDATE_OI_CHANGE_TIME_PERIOD';
const TOGGLE_OI_CHANGE_EXPIRY = 'TOGGLE_OI_CHANGE_EXPIRY';
const TOGGLE_OI_CHANGE_ALL_EXPIRIES = 'TOGGLE_OI_CHANGE_ALL_EXPIRIES';

// Taker activity Chart Types
const UPDATE_TAKER_ACTIVITY_EXPIRIES = 'UPDATE_TAKER_ACTIVITY_EXPIRIES';
const UPDATE_TAKER_ACTIVITY_ACTIVE_ASSET = 'UPDATE_TAKER_ACTIVITY_ACTIVE_ASSET';
const UPDATE_TAKER_ACTIVITY_TIME_PERIOD = 'UPDATE_TAKER_ACTIVITY_TIME_PERIOD';
const TOGGLE_TAKER_ACTIVITY_ALL_EXPIRIES = 'TOGGLE_TAKER_ACTIVITY_ALL_EXPIRIES';
const TOGGLE_TAKER_ACTIVITY_EXPIRY = 'TOGGLE_TAKER_ACTIVITY_EXPIRY';
const UPDATE_TAKER_ACTIVITY_LOADING_DATA = 'UPDATE_TAKER_ACTIVITY_LOADING_DATA';
const UPDATE_TAKER_ACTIVITY_ERROR = 'UPDATE_TAKER_ACTIVITY_ERROR';
const UPDATE_TAKER_ACTIVITY_SOCKET_DATA = 'UPDATE_TAKER_ACTIVITY_SOCKET_DATA';
const UPDATE_TAKER_ACTIVITY_DATA = 'UPDATE_TAKER_ACTIVITY_DATA';

export {
  UPDATE_EXPIRIES,
  UPDATE_FORMATTED_EXPIRIES,
  UPDATE_OPEN_INTEREST_SELECTED_EXPIRIES,
  TOGGLE_OPEN_INTEREST_SELECTED_EXPIRIES,
  UPDATE_ASSET_SYMBOL,
  UPDATE_MAX_PAIN,
  TOGGLE_OPEN_INTEREST_ALL_EXPIRIES,
  UPDATE_IMPLIED_VOLATILITY_SELECTED_EXPIRIES,
  UPDATE_IMPLIED_VOLATILITY_ASSET_SYMBOL,
  TOGGLE_IMPLIED_VOLATILITY_SELECTED_EXPIRY,
  UPDATE_VOLUME_STRIKE_CHART_ACTIVE_ASSET_SYMBOL,
  UPDATE_VOLUME_STRIKE_CHART_INITIAL_SELECTED_EXPIRIES,
  TOGGLE_VOLUME_STRIKE_CHART_ALL_EXPIRIES,
  TOGGLE_VOLUME_STRIKE_CHART_SELECTED_EXPIRIES,
  UPDATE_OI_CHANGE_ASSET_SYMBOL,
  UPDATE_OI_CHANGE_EXPIRIES,
  UPDATE_OI_CHANGE_TIME_PERIOD,
  TOGGLE_OI_CHANGE_EXPIRY,
  TOGGLE_OI_CHANGE_ALL_EXPIRIES,
  UPDATE_TAKER_ACTIVITY_EXPIRIES,
  UPDATE_TAKER_ACTIVITY_ACTIVE_ASSET,
  UPDATE_TAKER_ACTIVITY_TIME_PERIOD,
  TOGGLE_TAKER_ACTIVITY_ALL_EXPIRIES,
  TOGGLE_TAKER_ACTIVITY_EXPIRY,
  UPDATE_TAKER_ACTIVITY_LOADING_DATA,
  UPDATE_TAKER_ACTIVITY_ERROR,
  UPDATE_TAKER_ACTIVITY_SOCKET_DATA,
  UPDATE_TAKER_ACTIVITY_DATA,
};
